import { Pipe, PipeTransform } from '@angular/core';
import { isBlank } from '@app/utils/string';

@Pipe({
  name: 'isBlank',
  standalone: false,
})
export class IsBlankPipe implements PipeTransform {
  transform(value: string): boolean {
    return isBlank(value);
  }
}
